import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, CheckCircle2, ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';
import { companyInfo } from '../../mock';

export const WhatWeDo = () => (
      <section id="what-we-do" className="py-20 bg-white border-b border-gray-100" data-testid="what-we-do-section">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-16 max-w-6xl mx-auto">
            {/* What we do */}
            <div>
              <div className="inline-block bg-yellow-100 border border-yellow-300 text-yellow-800 text-xs font-semibold tracking-widest uppercase rounded-full px-3 py-1 mb-4">
                What We Do
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
                Six services Brooklyn calls us for first
              </h2>
              <ul className="space-y-3">
                {[
                  { label: 'EV charger installation', path: '/ev-charger-installation-brooklyn' },
                  { label: '200A panel upgrades', path: '/panel-upgrade-brooklyn' },
                  { label: 'Generator installation', path: '/generator-installation-brooklyn' },
                  { label: 'Smart-home wiring', path: '/smart-home-wiring-brooklyn' },
                  { label: '24/7 emergency repairs', path: '/emergency-electrician-brooklyn' },
                  { label: 'Christmas light installation', path: '/christmas-light-installation-brooklyn' },
                ].map((svc) => (
                  <li key={svc.path}>
                    <Link
                      to={svc.path}
                      className="group flex items-center justify-between py-3 px-4 rounded-lg border border-gray-200 hover:border-yellow-400 hover:bg-yellow-50 transition-all"
                      data-testid={`what-we-do-link-${svc.path.replace('/', '')}`}
                    >
                      <span className="font-medium text-gray-900 group-hover:text-black">
                        {svc.label}
                      </span>
                      <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-yellow-500 group-hover:translate-x-1 transition-transform" />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Why Brooklyn chooses Jetco */}
            <div>
              <div className="inline-block bg-gray-900 text-yellow-400 text-xs font-semibold tracking-widest uppercase rounded-full px-3 py-1 mb-4">
                Why Brooklyn Chooses Jetco
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
                Reliable, honest electrical work &mdash; day or night
              </h2>
              <ul className="space-y-4">
                {[
                  'Open 24/7 with same-day service',
                  'Free estimates with upfront pricing',
                  'Clean, careful work in homes, apartments and storefronts',
                  'Serving Brooklyn, Queens and Manhattan',
                ].map((reason) => (
                  <li key={reason} className="flex items-start space-x-3">
                    <CheckCircle2 className="w-6 h-6 text-yellow-500 flex-shrink-0 mt-0.5" />
                    <span className="text-gray-700 text-base">{reason}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-8 p-5 bg-gray-900 rounded-xl border border-yellow-400/30">
                <p className="text-gray-200 mb-3 text-sm">Need an electrician right now?</p>
                <a href={`tel:${companyInfo.phone}`} data-testid="what-we-do-phone-cta">
                  <Button className="w-full bg-yellow-400 hover:bg-yellow-300 text-black font-bold">
                    <Phone className="w-5 h-5 mr-2" />
                    Call or text {companyInfo.phone}
                  </Button>
                </a>
                <p className="text-gray-400 text-xs mt-3 text-center">Free estimates &mdash; no obligation</p>
              </div>
            </div>
          </div>
        </div>
      </section>
);
